/**
 * Auto-link collection names inside blog article content (first match per phrase).
 */
(function () {
  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function linkPhrasesInContent() {
    const dataEl = document.getElementById('sb-blog-link-data');
    const content = document.querySelector('.article-template__content');
    if (!dataEl || !content) return;

    let links;
    try {
      links = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    links.forEach(({ phrase, url }) => {
      if (!phrase || !url) return;
      const regex = new RegExp(`(?![^<]*>)\\b(${escapeRegExp(phrase)})\\b`, 'i');
      if (!regex.test(content.innerHTML)) return;

      content.innerHTML = content.innerHTML.replace(regex, `<a href="${url}" class="sb-blog-inline-link">$1</a>`);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', linkPhrasesInContent);
  } else {
    linkPhrasesInContent();
  }
})();
